export default {
  tournamentsMembersData: [],
  currentRoundData: {},
  tournamentsMyRatingData: {},
};